import type { AchievementDefinition } from "./achievements";

/** Display copy only. Eligibility and progress live in the server's versioned registry. */
const badges = [
  ["underdog-whisperer", "Underdog Whisperer", "Pick four underdog winners in one week.", "target"],
  ["giant-killer", "Giant Killer", "Pick four winners at +300 odds or longer.", "bullseye"],
  ["long-shot-legend", "Long Shot Legend", "Pick two winners at +600 odds or longer.", "bullseye"],
  ["road-warrior", "Road Warrior", "Pick seven away-team winners in one week.", "flag"],
  ["home-field-oracle", "Home-Field Oracle", "Pick eight home-team winners in one week.", "flag"],
  ["hook-hunter", "Hook Hunter", "Win five spread picks by less than a point.", "target"],
  ["cover-artist", "Cover Artist", "Get ten spread picks right in one week.", "target"],
  ["overdrive", "Overdrive", "Get seven over picks right in one week.", "flame"],
  ["understudy", "Understudy", "Get seven under picks right in one week.", "target"],
  ["prop-shop", "Prop Shop", "Get ten custom prop picks right this season.", "check"],
  ["four-tool-captain", "Four-Tool Captain", "Win a moneyline, spread, total, and prop pick in the same week.", "clipboard"],
  ["same-game-sweep", "Same-Game Sweep", "Get every pick for one game right.", "bullseye"],
  ["primetime-prophet", "Primetime Prophet", "Pick eight primetime winners this season.", "flag"],
  ["london-calling", "London Calling", "Pick every international-game winner this season.", "flag"],
  ["division-decoder", "Division Decoder", "Pick eight division-game winners this season.", "target"],
  ["four-week-furnace", "Four-Week Furnace", "Get 70% of your picks right for four weeks in a row.", "flame"],
  ["hat-trick", "Hat Trick", "Win three weeks in a row.", "trophy"],
  ["bookend-bandit", "Bookend Bandit", "Win both the first and last week of the season.", "trophy"],
  ["standings-sniper", "Standings Sniper", "Climb five places in the weekly rankings three times.", "target"],
  ["early-bird-special", "Early Bird Special", "Finish your card a day early in six different weeks.", "clipboard"],
  ["iron-slate", "Iron Slate", "Fill out your entire card for ten weeks in a row.", "clipboard"],
  ["no-blank-sundays", "No Blank Sundays", "Get a pick right for twelve weeks in a row.", "check"],
  ["bounce-back-artist", "Bounce-Back Artist", "Follow a rough week with 80% accuracy or better.", "flame"],
  ["century-club", "Century Club", "Get 100 picks right this season.", "check"],
  ["the-locksmith", "The Locksmith", "Get 80% of your picks right across the season.", "target"],
  ["steady-eddie", "Steady Eddie", "Get 65% of your picks right in twelve different weeks.", "check"],
  ["double-digit-champ", "Double-Digit Champ", "Win ten weeks in one season.", "trophy"],
  ["dog-money", "Dog Money", "Get 60% of your underdog picks right this season.", "target"],
  ["small-slate-specialist", "Small-Slate Specialist", "Get 80% of your picks right on the season's smallest card.", "bullseye"],
  ["never-say-die", "Never Say Die", "Rally from outside the top quarter to finish in the top two.", "trophy"],
] as const;

export type ExpandedAchievementBadgeKey = typeof badges[number][0];

export const EXPANDED_ACHIEVEMENT_DEFINITIONS: readonly AchievementDefinition[] = badges.map(
  ([key, title, rule, icon], index) => ({
    key,
    title,
    description: rule,
    rule,
    icon,
    repeatable: false,
    displayOrder: index + 8,
    ruleVersion: 2,
  }),
);
